export default {
  components: {
  },
  data() {
    return {
      arr: [{name: '标的信息', key: 'landInfo'}, {name: '项目基本信息', key: 'basicInfo'}, {name: '瑕疵声明及重大事项提示', key: 'issuesInfo'}, {name: '出租方承诺', key: 'promiseInfo'}, {name: '现场勘验', key: 'sceneInfo'}, {name: '承租方资格条件', key: 'conditionInfo'}, {name: '交易报名', key: 'signupInfo'}, {name: '竞价保证金及处置方式', key: 'bondInfo'}, {name: '征集意向受让方', key: 'solicitationInfo'}, {name: '竞价时间', key: 'biddingtimeInfo'}, {name: '标的交割', key: 'deliveryInfo'}, {name: '咨询信息', key: 'serviceInfo'}, {name: '附件下载', key: 'enclosureInfo'}],
      activeKey: 'landInfo',
      navTop: null
    };
  },
  created() {
  },
  computed: {
  },
  mounted () {
    this.$nextTick(function () {
      this.navTop = document.getElementById('navList').offsetTop;
      window.addEventListener('scroll', this.handleScroll);
    });
  },
  methods: {
    handleScroll() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 获取滑动距离
      const landInfoScrollHeight = document.getElementById('landInfo').offsetTop;
      const basicInfoScrollHeight = document.getElementById('basicInfo').offsetTop;
      const transfereeInfoScrollHeight = document.getElementById('transfereeInfo') && document.getElementById('transfereeInfo').offsetTop;
      if (scrollTop > this.navTop) {
        document.getElementById('navList').style = 'position: fixed';
      } else if (scrollTop < (this.navTop - 43)) {
        document.getElementById('navList').style = 'position: relative';
      }
      if (scrollTop >= (transfereeInfoScrollHeight - 43)) {
        this.activeKey = 'transfereeInfo';
      } else if (scrollTop >= (basicInfoScrollHeight - 43)) {
        this.activeKey = 'basicInfo';
      } else if (scrollTop >= (landInfoScrollHeight -43)) {
        this.activeKey = 'landInfo';
      }
    },
    changeActiveIndex (key) {
      this.activeKey = key;
      document.body.scrollTop = document.documentElement.scrollTop = (document.getElementById(key).offsetTop - 43);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
